import type { Page, ReceiptClearInput, ReceiptDetailView, ReceiptInput, ReceiptListQuery, ReceiptReasonInput, ReceiptView } from '@chukua/common';
import { api } from '../../../../shared/shared.api';
import { toListParams } from '../../../../shared/policies/list-params';

export type { ReceiptDetailView, ReceiptView };

export function listReceipts(query: ReceiptListQuery): Promise<Page<ReceiptView>> {
  return api<Page<ReceiptView>>(`/receipts?${toListParams(query)}`);
}

export function getReceipt(id: string): Promise<ReceiptDetailView> {
  return api<ReceiptDetailView>(`/receipts/${id}`);
}

export function clearReceipt(id: string, input: ReceiptClearInput): Promise<ReceiptDetailView> {
  return api<ReceiptDetailView>(`/receipts/${id}/clear`, { method: 'POST', body: JSON.stringify(input) });
}

export function bounceReceipt(id: string, input: ReceiptReasonInput): Promise<ReceiptDetailView> {
  return api<ReceiptDetailView>(`/receipts/${id}/bounce`, { method: 'POST', body: JSON.stringify(input) });
}

export function reverseReceipt(id: string, input: ReceiptReasonInput): Promise<ReceiptDetailView> {
  return api<ReceiptDetailView>(`/receipts/${id}/reverse`, { method: 'POST', body: JSON.stringify(input) });
}

export function recordReceipt(input: ReceiptInput): Promise<ReceiptView> {
  return api<ReceiptView>('/receipts', { method: 'POST', body: JSON.stringify(input) });
}
